import { requiredStrategy } from '../core';
import { taiwanIdNumberFormatStrategy } from './taiwan-id-number-format-strategy';
import { taiwanIdNumberLengthStrategy } from './taiwan-id-number-length-strategy';

export const taiwanIdNumberStrategy = (value: string) => {
  return (
    requiredStrategy(value) &&
    taiwanIdNumberLengthStrategy(value) &&
    taiwanIdNumberFormatStrategy(value)
  );
};
